module.exports = __webpack_public_path__ + "static/img/jingkai.8053c90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/serviceCenter/jingkai.png
// module id = pZOS
// module chunks = 44